import { Badge } from '@/components/ui/badge'
import { BadgeCheck, CircleOff, Globe2, Wrench } from 'lucide-react'

const floristStatusConfig = {
  live: {
    label: 'Live',
    variant: 'success',
    icon: BadgeCheck,
  },
  lost: {
    label: 'Lost',
    variant: 'destructive',
    icon: CircleOff,
  },
  needs_setup: {
    label: 'Needs Setup',
    variant: 'muted',
    icon: Wrench,
  },
  non_florist: {
    label: 'Non-Florist',
    variant: 'outline',
    icon: Globe2,
  },
}

export function getFloristStatusConfig(status) {
  return floristStatusConfig[status] ?? floristStatusConfig.needs_setup
}

export function getFloristStatusLabel(status) {
  return getFloristStatusConfig(status).label
}

export function FloristStatusBadge({ status }) {
  const config = getFloristStatusConfig(status)
  const StatusIcon = config.icon

  return (
    <Badge variant={config.variant}>
      <StatusIcon />
      {config.label}
    </Badge>
  )
}
